import React from 'react';
import { useTranslation } from 'react-i18next';

const PlanName = ( { planName, className } ) => {
    const { t } = useTranslation();

    const planNames = { // TODO: ON BACKEND THIS SHOULD BE ENUM, NOT STRING IN DATABASE!
        free: t('plan.free'),
        basic: t('plan.basic'),
        advanced: t('plan.advanced'),
        pro: t('plan.pro'),
        'free-basic': t('plan.basic'),
        'free-advanced': t('plan.advanced'),
        'free-pro': t('plan.free-pro'),
    };

    return (
        <span className={className}>{planNames[planName]}</span>
    );
};

export default PlanName;
